import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteModel } from '../api/models';
import { ModelColor, ModelType } from '../models/Model';
import { customConfirm } from '../utils/utils';
import { Button } from './Button';
import S from './ModelItem.styl';
var ModelItem = /** @class */ (function (_super) {
    __extends(ModelItem, _super);
    function ModelItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var model = _this.props.model;
            if (model) {
                customConfirm(i18n.modelsDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: model.id,
                        };
                        deleteModel(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.model);
            }
        };
        return _this;
    }
    ModelItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    ModelItem.prototype.getTypeText = function (type) {
        var i18n = this.props.store.i18n;
        if (type === ModelType.dry) {
            return i18n.dry;
        }
        else if (type === ModelType.damp) {
            return i18n.damp;
        }
        else {
            return i18n.wet;
        }
    };
    ModelItem.prototype.getColorText = function (color) {
        var i18n = this.props.store.i18n;
        if (color === ModelColor.black) {
            return i18n.black;
        }
        else if (color === ModelColor.red) {
            return i18n.red;
        }
        else if (color === ModelColor.yellow) {
            return i18n.yellow;
        }
        else {
            return i18n.infected;
        }
    };
    ModelItem.prototype.render = function () {
        var props = this.props;
        var model = props.model;
        var i18n = props.store.i18n;
        var loading = this.state.loading;
        return (React.createElement("div", { className: S.modelItem }, model ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell }, model.title),
                React.createElement("div", { className: S.tableCell }, this.getColorText(model.color || ModelColor.black)),
                React.createElement("div", { className: S.tableCell }, this.getTypeText(model.type || ModelType.dry)),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    ModelItem = __decorate([
        inject('store'),
        observer
    ], ModelItem);
    return ModelItem;
}(React.Component));
export { ModelItem };
